/* ==========================================================================
   ZPK — Ricerca rapida dall'header
   La lente dell'header apre un pannello (<dialog id="zpk-search">, in
   sections/zpk-header.liquid) con il campo di ricerca. Mentre si scrive,
   sotto compaiono suggerimenti, collezioni e copertine dei prodotti trovati,
   presi dalla ricerca predittiva di Shopify; Invio o «Vedi tutti i
   risultati» portano alla pagina /search, quella con i filtri.

   Senza JavaScript la lente resta un link a /search: si perde l'anteprima,
   non la ricerca.

   Tutto delegato sul document, come in zpk-theme.js: il theme editor
   rirenderizza l'header e il pannello va ritrovato ogni volta.
   ========================================================================== */
(function () {
  'use strict';

  const SECTION = 'zpk-predictive-search';
  const MIN_CHARS = 2;
  const DELAY = 250;
  // 10 e' il massimo che la ricerca predittiva di Shopify restituisce.
  const LIMIT = 10;

  /* IN QUALI CAMPI CERCA L'ANTEPRIMA.
     Dichiarati apposta: i TAG, dove il catalogo mette le parole fatte per
     essere trovate (generi, temi, autori, keyword: «Horror solo-ricerca»,
     con la parola in testa), e barcode e sku, cioe' l'ISBN. La
     documentazione della ricerca predittiva da' come campi di serie solo
     title, product_type, variants.title e vendor.
     Provato il 21 settembre 2026 sul negozio J-POP: con o senza questo
     parametro i risultati sono identici (ISBN compreso, e «alieni» trova gia'
     DanDaDan, Cosmos e Mazinsaga senza che nessun volume abbia quel tag: e' la
     ricerca semantica di Shopify). Resta scritto perche' e' la garanzia che
     l'anteprima cerchi dove cerca la pagina /search, anche se Shopify
     cambiasse i default.
     `body` no: la descrizione darebbe risultati di passaggio (una trama che
     nomina gli alieni non fa di un volume un manga sugli alieni). La pagina
     completa la cerca comunque.
     Niente `product_type` dal 7/10/2026 (richiesta dell'utente): il «Tipo» lo
     scrive il plugin del distributore, FUMETTI anche sui manga, e cercando
     «fumetti» su J-POP uscivano circa 4.500 manga. */
  const FIELDS = 'title,vendor,variants.title,tag,variants.barcode,variants.sku';

  const $  = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  const cache = new Map();
  let controller = null;
  let timer = null;
  let opener = null;
  let pressedOnBackdrop = false;

  function parts() {
    const dialog = $('#zpk-search');
    if (!dialog) return null;
    return {
      dialog,
      form: $('[data-zpk-search-form]', dialog),
      input: $('[data-zpk-search-input]', dialog),
      clear: $('[data-zpk-search-clear]', dialog),
      idle: $('[data-zpk-search-idle]', dialog),
      live: $('[data-zpk-search-live]', dialog),
      status: $('[data-zpk-search-status]', dialog),
      body: $('[data-zpk-search-body]', dialog),
      recent: $('[data-zpk-search-recent]', dialog),
      recentList: $('[data-zpk-search-recent-list]', dialog)
    };
  }

  /* --- Ricerche recenti -------------------------------------------------
     Le ultime 5 ricerche portate a termine, dalla piu' recente, nella
     memoria del browser (localStorage). Non passano mai dal negozio: restano
     sul dispositivo di chi le ha fatte, e «Cancella» le toglie.
     Si salva quando una ricerca arriva da qualche parte (Invio, un
     risultato, un suggerimento, «Vedi tutti»), non a ogni tasto: altrimenti
     l'elenco si riempirebbe di parole lasciate a meta' («dand», «danda»).
     Uguali senza badare a maiuscole e spazi: «DanDaDan» sostituisce
     «dandadan» e sale in cima, non si aggiunge.
     Se la memoria del browser e' negata (navigazione privata di alcuni
     browser, siti bloccati) il riquadro semplicemente non compare. */
  const RECENT_KEY = 'jpop-ricerche-recenti';
  const RECENT_MAX = 5;

  function normalize(terms) {
    return String(terms || '').replace(/\s+/g, ' ').trim().slice(0, 80);
  }

  function readRecent() {
    try {
      const list = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) ? list.filter((t) => typeof t === 'string' && t).slice(0, RECENT_MAX) : [];
    } catch (e) {
      return [];
    }
  }

  function writeRecent(list) {
    try {
      if (list.length) window.localStorage.setItem(RECENT_KEY, JSON.stringify(list));
      else window.localStorage.removeItem(RECENT_KEY);
    } catch (e) { /* memoria negata: si rinuncia all'elenco, non alla ricerca */ }
  }

  function remember(terms) {
    const clean = normalize(terms);
    if (clean.length < MIN_CHARS) return;
    const key = clean.toLowerCase();
    const list = readRecent().filter((t) => t.toLowerCase() !== key);
    list.unshift(clean);
    writeRecent(list.slice(0, RECENT_MAX));
  }

  // Ogni ricerca recente e' un bottone e non un link: la si rimette nel
  // campo e si vede di nuovo l'anteprima, senza lasciare il pannello.
  function paintRecent(p) {
    if (!p.recent || !p.recentList) return;
    const list = readRecent();
    p.recentList.replaceChildren(...list.map((terms) => {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zpk-search__pill';
      btn.dataset.zpkSearchRecentTerm = terms;
      btn.textContent = terms;
      li.append(btn);
      return li;
    }));
    p.recent.hidden = list.length === 0;
  }

  /* --- Annunci ----------------------------------------------------------
     La regione role="status" sta nel pannello fin dal primo render: una
     regione creata nel momento in cui cambia il testo non viene letta. */
  function say(p, message) {
    if (!p.status) return;
    p.status.textContent = '';
    window.setTimeout(() => { p.status.textContent = message; }, 60);
  }

  function summary(fresh) {
    const products = Number(fresh.dataset.zpkSearchProducts) || 0;
    const total = Number(fresh.dataset.zpkSearchTotal) || 0;
    const terms = fresh.dataset.zpkSearchTerms || '';
    if (!total) return 'Nessun risultato per «' + terms + '».';
    if (!products) return 'Nessun prodotto per «' + terms + '», ci sono suggerimenti.';
    const head = products >= LIMIT
      ? 'Primi ' + products + ' risultati'
      : products === 1 ? '1 risultato' : products + ' risultati';
    return head + ' per «' + terms + '». Freccia giù per sceglierli.';
  }

  /* --- Stati del pannello ------------------------------------------------ */
  function showIdle(p) {
    p.live.hidden = true;
    p.live.replaceChildren();
    p.idle.hidden = false;
    p.body?.removeAttribute('aria-busy');
  }

  function render(p, html) {
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-zpk-search-live]');
    if (!fresh) return;
    const total = Number(fresh.dataset.zpkSearchTotal) || 0;
    p.live.replaceChildren(...Array.from(fresh.childNodes));
    p.live.hidden = false;
    // Senza risultati restano visibili anche le scorciatoie: meglio di una
    // pagina vuota con solo «nessun risultato».
    p.idle.hidden = total > 0;
    p.body?.removeAttribute('aria-busy');
    say(p, summary(fresh));
  }

  function renderError(p, terms) {
    const box = document.createElement('div');
    box.className = 'zpk-search__empty';
    const text = document.createElement('p');
    text.textContent = 'L\'anteprima non è disponibile in questo momento. Premi Invio per cercare «' + terms + '» in tutto il catalogo.';
    box.append(text);
    p.live.replaceChildren(box);
    p.live.hidden = false;
    p.idle.hidden = true;
    p.body?.removeAttribute('aria-busy');
    say(p, text.textContent);
  }

  function suggestUrl(p, terms) {
    const params = new URLSearchParams({
      q: terms,
      section_id: SECTION,
      'resources[type]': 'product,query,collection',
      'resources[limit]': String(LIMIT),
      'resources[limit_scope]': 'each',
      /* I VOLUMI ESAURITI RESTANO AL LORO POSTO (7 ottobre 2026).
         Con 'last' Shopify li sposta in fondo all'elenco, e quelli oltre il
         decimo spariscono: cercando «nina th» il volume 2 di «Nina the
         Starry Bride», esaurito, era il nono di nove e veniva tagliato, pur
         comparendo nella pagina completa dei risultati — che gli esauriti
         non li sposta. Due schermate diverse per la stessa ricerca.
         Con 'show' l'ordine e' quello di pertinenza, come nella pagina, e
         chi cerca una serie la vede intera. Che il volume non si possa
         comprare lo dice l'etichetta «Esaurito» sulla copertina
         (sections/zpk-predictive-search.liquid). */
      'resources[options][unavailable_products]': 'show',
      'resources[options][fields]': FIELDS
    });
    return (p.dialog.dataset.zpkSearchUrl || '/search/suggest') + '?' + params.toString();
  }

  /* I VOLUMI PIU' RECENTI PRIMA (9 ottobre 2026, richiesta del cliente).
     La ricerca predittiva da' al massimo 10 prodotti scelti per pertinenza, e
     cercando «firefly» i volumi 12 e 10, i piu' nuovi, restavano fuori. Allora
     la stessa sezione si chiede anche alla ricerca completa: li' prende i 250
     risultati piu' pertinenti, li ordina per data di uscita e ne stampa 10
     (sections/zpk-predictive-search.liquid). Dalla ricerca completa si prende
     solo il gruppo «Prodotti»; suggerimenti, collezioni e «Vedi tutti»
     restano quelli della predittiva. Se la ricerca completa non risponde, il
     pannello resta quello della sola predittiva. */
  function fullUrl(p, terms) {
    const base = (p.dialog.dataset.zpkSearchUrl || '/search/suggest').replace(/\/suggest\/?$/, '');
    const params = new URLSearchParams({
      q: terms,
      type: 'product',
      'options[prefix]': 'last',
      'options[unavailable_products]': 'show',
      section_id: SECTION
    });
    return base + '?' + params.toString();
  }

  function mergeProducts(suggestHtml, fullHtml) {
    if (!fullHtml) return suggestHtml;
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-zpk-search-live]');
    const live = parse(suggestHtml);
    const full = parse(fullHtml);
    if (!live || !full) return suggestHtml;
    const groupOf = (root) => root.querySelector('.zpk-search__products')?.closest('.zpk-search__group') || null;
    const fullGroup = groupOf(full);
    if (!fullGroup) return suggestHtml;
    const count = (root, name) => Number(root.dataset[name]) || 0;
    // La predittiva non ha trovato niente da mostrare ma la completa si': vale
    // la risposta della completa, che ha anche il suo «Vedi tutti».
    if (count(live, 'zpkSearchTotal') === 0) return full.outerHTML;
    const group = groupOf(live);
    if (group) group.replaceWith(fullGroup);
    else live.querySelector('.zpk-search__all')?.before(fullGroup);
    const before = count(live, 'zpkSearchProducts');
    const after = count(full, 'zpkSearchProducts');
    live.dataset.zpkSearchProducts = String(after);
    live.dataset.zpkSearchTotal = String(count(live, 'zpkSearchTotal') - before + after);
    return live.outerHTML;
  }

  async function search(p, terms) {
    if (cache.has(terms)) { render(p, cache.get(terms)); return; }
    if (controller) controller.abort();
    controller = new AbortController();
    p.body?.setAttribute('aria-busy', 'true');
    try {
      const signal = controller.signal;
      const fullRequest = fetch(fullUrl(p, terms), { signal })
        .then((r) => (r.ok ? r.text() : ''))
        .catch((e) => { if (e && e.name === 'AbortError') throw e; return ''; });
      fullRequest.catch(() => {});   // se la predittiva fallisce prima, nessun errore «non gestito»
      const res = await fetch(suggestUrl(p, terms), { signal });
      if (!res.ok) throw new Error('predictive search ' + res.status);
      const html = mergeProducts(await res.text(), await fullRequest);
      cache.set(terms, html);
      // Nel frattempo si e' continuato a scrivere: questa risposta e' vecchia.
      if (p.input.value.trim() !== terms) return;
      render(p, html);
    } catch (e) {
      if (e && e.name === 'AbortError') return;
      renderError(p, terms);
    }
  }

  function onInput(p) {
    const terms = p.input.value.trim();
    p.clear.hidden = !p.input.value;
    window.clearTimeout(timer);
    if (terms.length < MIN_CHARS) {
      if (controller) controller.abort();
      showIdle(p);
      return;
    }
    timer = window.setTimeout(() => search(p, terms), DELAY);
  }

  /* --- Apertura e chiusura ---------------------------------------------- */
  function open(from) {
    const p = parts();
    if (!p || p.dialog.open) return;
    opener = from || null;
    // A ogni apertura, non una volta sola: le ricerche fatte in un'altra
    // scheda devono comparire anche qui.
    paintRecent(p);
    if (typeof p.dialog.showModal === 'function') p.dialog.showModal();
    else p.dialog.setAttribute('open', '');
    $$('[data-zpk-search-open]').forEach((el) => el.setAttribute('aria-expanded', 'true'));
    p.input.focus();
    // Riaprendo si ritrova l'ultima ricerca, selezionata: si riscrive sopra
    // con un tasto solo. I suoi risultati si richiedono di nuovo (di solito
    // arrivano dalla cache): se si era chiuso prima che partisse la
    // richiesta, il campo pieno sopra le sole scorciatoie non tornerebbe.
    p.input.select();
    if (p.input.value.trim()) onInput(p);
  }

  function close() {
    const p = parts();
    if (p && p.dialog.open) p.dialog.close();
  }

  // Il link a /search diventa il comando che apre il pannello. Gli attributi
  // si mettono qui e non nel Liquid: senza script sarebbero una promessa
  // falsa, perche' il link porta a una pagina e non apre niente.
  function upgradeOpeners() {
    $$('[data-zpk-search-open]').forEach((el) => {
      el.setAttribute('aria-haspopup', 'dialog');
      el.setAttribute('aria-controls', 'zpk-search');
      el.setAttribute('aria-expanded', 'false');
    });
  }

  /* --- Frecce: dal campo ai risultati e fra i risultati -------------------
     Tab funziona gia'; le frecce sono la scorciatoia che ci si aspetta da un
     campo che suggerisce. Freccia su dal primo risultato torna al campo.
     Le ricerche recenti sono bottoni e fanno parte del giro; «Cancella» no:
     con le frecce non si deve poter svuotare l'elenco per sbaglio. */
  function onArrow(p, event) {
    const pane = p.live.hidden ? p.idle : p.live;
    const links = $$('a[href], [data-zpk-search-recent-term]', pane).filter((a) => a.offsetParent !== null);
    if (!links.length) return;
    const current = document.activeElement;
    if (current === p.input) {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault();
      links[0].focus();
      return;
    }
    const i = links.indexOf(current);
    if (i === -1) return;
    event.preventDefault();
    if (event.key === 'ArrowDown') links[Math.min(i + 1, links.length - 1)].focus();
    else if (i === 0) p.input.focus();
    else links[i - 1].focus();
  }

  /* --- Dove deve stare la parola cercata ---------------------------------
     La ricerca del negozio risponde anche con i volumi che la nominano solo
     nella trama: «makoto» tirava dentro «Karma of Purgatory», che di Makoto
     Shinkai non e'. Il parametro options[fields] non serve, Shopify lo
     ignora; la sintassi per campo invece la rispetta, e allora Invio e «Vedi
     tutti i risultati» chiedono esattamente quella:
       (title:makoto OR tag:makoto OR vendor:makoto
        OR variants.sku:makoto OR variants.barcode:makoto)
     Gli autori stanno nei tag (`autore:Makoto Shinkai`), come i generi, i
     temi e le parole chiave «… solo-ricerca»: e' li' che la ricerca deve
     guardare. Con piu' parole, ognuna ha il suo gruppo e i gruppi si legano
     con AND.
     ⚠️ Cosi' NON si trovano le parole lasciate a meta': `tag:makot` non da'
     niente (provato). Nel pannello, mentre si scrive, la richiesta resta
     quella normale — che le parole a meta' le trova — e a scartare i volumi
     fuori bersaglio pensa il Liquid (sections/zpk-predictive-search.liquid).
     Lo stesso indirizzo lo costruisce anche quella sezione: se cambia qui,
     cambialo li'. */
  // Senza product_type dal 7/10/2026: vedi FIELDS in cima.
  const SCOPE_FIELDS = ['title', 'tag', 'vendor', 'variants.sku', 'variants.barcode'];

  function strictQuery(text) {
    const words = String(text || '')
      .toLowerCase()
      .split(/\s+/)
      .map((w) => w.replace(/["()]/g, '').replace(/:/g, ' ').trim())
      .filter(Boolean);
    if (!words.length) return '';
    return words.map((w) => '(' + SCOPE_FIELDS.map((f) => f + ':' + w).join(' OR ') + ')').join(' AND ');
  }

  // `zq` porta le parole come sono state scritte: la pagina dei risultati le
  // rimette al posto della query per esteso (sotto, showTypedWords).
  function resultsUrl(text) {
    const strict = strictQuery(text);
    if (!strict) return '';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'search?' + new URLSearchParams({ q: strict, type: 'product', zq: String(text).trim() }).toString();
  }

  function broadUrl(text) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'search?' + new URLSearchParams({ q: String(text).trim(), type: 'product' }).toString();
  }

  /* --- Pagina dei risultati ----------------------------------------------
     Due ritocchi, perche' la query per campo e' esatta ma illeggibile:
     1. dove la pagina scrive la ricerca fatta (titolo della scheda, titolo
        della pagina, briciole di pane) si rimettono le parole scritte;
     2. se nessun volume porta quella parola dove deve stare, invece di una
        pagina vuota si offre la ricerca larga, quella che legge anche le
        trame. Senza, «alieni» — che oggi non e' tag di nessun volume —
        sarebbe un vicolo cieco. */
  function showTypedWords(raw, typed) {
    if (!raw || raw === typed) return;
    if (document.title.indexOf(raw) !== -1) document.title = document.title.split(raw).join(typed);
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const hits = [];
    while (walker.nextNode()) {
      if (walker.currentNode.nodeValue.indexOf(raw) !== -1) hits.push(walker.currentNode);
    }
    hits.forEach((node) => { node.nodeValue = node.nodeValue.split(raw).join(typed); });
  }

  function offerBroadSearch(typed) {
    // La griglia di Xtra c'e' solo se qualche prodotto e' stato trovato.
    if (document.getElementById('collection')) return;
    const host = $('main .results') || $('main');
    if (!host) return;
    const box = document.createElement('div');
    box.className = 'zpk zpk-search__fallback';
    const title = document.createElement('p');
    title.className = 'zpk-search__empty-title';
    title.textContent = 'Nessun volume con «' + typed + '» nel titolo, nell’autore, nella serie, nei tag o nell’ISBN.';
    const hint = document.createElement('p');
    hint.textContent = 'Puoi allargare la ricerca al testo delle schede.';
    const link = document.createElement('a');
    link.className = 'zpk-btn zpk-btn--yellow';
    link.href = broadUrl(typed);
    link.textContent = 'Cerca «' + typed + '» anche nelle trame';
    box.append(title, hint, link);
    host.prepend(box);
  }

  // Le parole scritte si ricavano anche dalla richiesta per campo: alla
  // seconda pagina, cambiando ordinamento o filtrando, `zq` non c'e' piu'
  // (Xtra rifa' l'indirizzo con il solo `q`). Stesso conto del Liquid in
  // snippets/zpk-search-terms.liquid, che e' quello che sistema i testi.
  function typedFromQuery(raw) {
    if (!raw || raw.indexOf('(title:') === -1) return '';
    return raw.split('(title:').slice(1)
      .map((chunk) => chunk.split(' ')[0].replace(/\)/g, '').trim())
      .filter(Boolean)
      .join(' ');
  }

  function initResultsPage() {
    const params = new URLSearchParams(window.location.search);
    const typed = params.get('zq') || typedFromQuery(params.get('q') || '');
    if (!typed) return;
    showTypedWords(params.get('q') || '', typed);
    offerBroadSearch(typed);
    // Riaprendo il pannello si ritrovano le parole scritte, non la query.
    const p = parts();
    if (p && !p.input.value) {
      p.input.value = typed;
      if (p.clear) p.clear.hidden = false;
    }
  }

  function init() {
    if (document.body.dataset.zpkSearchBound) return;
    document.body.dataset.zpkSearchBound = '1';
    upgradeOpeners();
    initResultsPage();

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-zpk-search-open]');
      if (trigger) {
        // Ctrl/Cmd/Maiusc + clic: si vuole la pagina di ricerca in un'altra
        // scheda, e il link la da'.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        if (!parts()) return;
        event.preventDefault();
        open(trigger);
        return;
      }
      if (event.target.closest('[data-zpk-search-close]')) { close(); return; }

      const clear = event.target.closest('[data-zpk-search-clear]');
      if (clear) {
        const p = parts();
        p.input.value = '';
        onInput(p);
        p.input.focus();
        return;
      }

      // Una ricerca recente torna nel campo, con la sua anteprima subito
      // (senza l'attesa pensata per chi sta scrivendo). Il fuoco va al campo:
      // da li' Invio porta a tutti i risultati, Freccia giu' ai prodotti.
      const again = event.target.closest('[data-zpk-search-recent-term]');
      if (again) {
        const p = parts();
        const terms = again.dataset.zpkSearchRecentTerm;
        p.input.value = terms;
        p.clear.hidden = false;
        window.clearTimeout(timer);
        p.input.focus();
        search(p, terms);
        return;
      }

      if (event.target.closest('[data-zpk-search-recent-clear]')) {
        const p = parts();
        writeRecent([]);
        paintRecent(p);
        // Il bottone e' sparito insieme al riquadro: il fuoco non deve
        // cadere sul fondo della pagina.
        p.input.focus();
        say(p, 'Ricerche recenti cancellate.');
        return;
      }

      // Un risultato scelto: la ricerca e' arrivata da qualche parte, si
      // ricorda. Per un suggerimento si ricorda il suggerimento («dandadan»),
      // non le lettere scritte fin li' («dand»).
      const hit = event.target.closest('#zpk-search [data-zpk-search-live] a[href]');
      if (hit) {
        const p = parts();
        remember(hit.dataset.zpkSearchTerm || (p && p.input.value));
        return;
      }

      // Clic sul fondo scuro, fuori dalla card: il <dialog> occupa tutto lo
      // schermo e la card e' dentro, quindi il bersaglio e' il dialog stesso.
      // Deve esserci anche la pressione: selezionando il testo del campo e
      // rilasciando fuori, il clic arriva al dialog e non deve chiudere.
      if (event.target.matches && event.target.matches('dialog.zpk-search') && pressedOnBackdrop) close();
    });

    document.addEventListener('pointerdown', (event) => {
      pressedOnBackdrop = Boolean(event.target.matches && event.target.matches('dialog.zpk-search'));
    });

    document.addEventListener('input', (event) => {
      if (!event.target.matches('[data-zpk-search-input]')) return;
      const p = parts();
      if (p) onInput(p);
    });

    document.addEventListener('submit', (event) => {
      if (!event.target.matches('[data-zpk-search-form]')) return;
      const p = parts();
      if (!p) return;
      // Invio a campo vuoto porterebbe a una pagina di ricerca vuota.
      if (!p.input.value.trim()) {
        event.preventDefault();
        p.input.focus();
        return;
      }
      remember(p.input.value);
      // Se l'anteprima e' gia' arrivata, Invio fa la stessa strada di «Vedi
      // tutti i risultati»: quell'indirizzo lo costruisce il Liquid, che sa
      // completare la parola lasciata a meta' («danda» → «dandadan»), cosa
      // che qui non si puo' sapere. Si usa solo se risponde alle parole che
      // ci sono adesso nel campo, non a quelle di un attimo prima.
      const live = $('[data-zpk-search-all]', p.dialog);
      if (live && live.dataset.zpkSearchAll === p.input.value.trim().toLowerCase()) {
        event.preventDefault();
        window.location.assign(live.getAttribute('href'));
        return;
      }
      const url = resultsUrl(p.input.value);
      if (!url) return;      // senza parole utilizzabili va il modulo com'e'
      event.preventDefault();
      window.location.assign(url);
    });

    document.addEventListener('keydown', (event) => {
      const p = parts();
      if (!p || !p.dialog.open) return;
      // Esc chiude sempre, anche col campo pieno. Il <dialog> lo farebbe da
      // se', ma dentro un campo di ricerca Chrome usa il primo Esc per
      // svuotarlo, e chi voleva solo chiudere perdeva quello che aveva
      // scritto. Cosi' il testo resta e si ritrova riaprendo. Serve anche dove
      // la chiusura nativa non arriva (sul banco, con i tasti simulati, non
      // arrivava nemmeno a un <dialog> vuoto): lo stesso fa il menu mobile.
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      if (p.dialog.contains(event.target)) onArrow(p, event);
    });

    // «close» non risale il DOM: lo si prende in cattura. Arriva sia da
    // Esc sia dalla X sia dal fondo.
    document.addEventListener('close', (event) => {
      if (!event.target.matches || !event.target.matches('dialog.zpk-search')) return;
      $$('[data-zpk-search-open]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
      window.clearTimeout(timer);
      if (controller) controller.abort();
      if (opener && document.contains(opener)) opener.focus();
      opener = null;
    }, true);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', upgradeOpeners);
})();
